import { Component, OnInit, ElementRef, ViewChild, TemplateRef, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../environments/environment'
import { OpportunityOfferOutputModel } from '../../shared/models/OpportunityOfferOutputModel'
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../shared/providers/toast.service';
import { CommonService } from '../../shared/providers/common.service';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { OffersSearchCriteriaModel } from '../../shared/models/OffersSearchCriteriaModel';
//import { CompleterService, CompleterData, Ng2CompleterModule } from 'ng2-completer';
//import { IMultiSelectOption, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { ValidationService } from '../../shared/providers/validation.service';
import { OfferService } from '../../shared/providers/offer.service';
import { INoteInput } from '../../shared/models/NotesInputModel';
import { LoaderService } from '../../shared/providers/loader.service';


export enum PropertyType {
  Sale = 601,
  Exchange1031 = 602
}

export enum OfferStatus {
  New = 451,
  Reviewed = 452,
  CounterAccepted = 453,
  CounterDeclined = 454,
  UnderContract = 455,
  Closed = 456,
  Rejected = 457,
  OfferModified = 458,
  Draft = 459,
  OfferAccepted = 460,
  Countered = 461,
  HardContract = 462,
  OnHold = 463,
  Delete = 464,
  Resume = 465,
  Cancelled = 466,
  Declined = 467,
  NoActivitySinceLast10Days = 0,
  Reset = -1
}

export enum Actions {
  NothingSelected = 0,
  Delete = 1,
  DownloadLOI = 2,
  ChangeStatus = 3
}

export enum UserRole {
  Admin = 0,
  Broker = 1,
  SuperAdmin=2
}


@Component({
  selector: 'app-offer-list',
  templateUrl: './offers-list.component.html',
  styleUrls: ['offers-list.component.css']
})
export class OffersListComponent implements OnInit {
  protected readonly BASE_URL: string = environment.base_url;
  dtOptions = {};
  table: DataTableDirective;
  offers: OpportunityOfferOutputModel[];
  modalRef: BsModalRef;
  selectedOfferId: number;
  currentIndex: number;
  isDisabled: boolean;
  statusList: ILookUp[];
  brokerNames = [];
  statusListForSearch = [];
  offersSearchCriteriaModel = {} as OffersSearchCriteriaModel;
  dataService: [];/*CompleterData;*/
  brokerDataService: []; /*CompleterData;*/
  inputStates = [];
  inputBrokers = [];
  user: any;
  selectedStatus = '';
  isSubmit = false;
  NotesInput = {} as INoteInput;
  fromPage: string = "BrokerOfferList";

  currentTab = PropertyType.Exchange1031;
  propertyType = PropertyType;
  offerStatus = OfferStatus;
  deletType = 'this offer';
  selectedBulkStatus = 0;
  loggedInUserRole = UserRole.Admin;
  userRole = UserRole;
  offersCount: number = 0;
  IsLoading = false;
  currentMenu = '';
  //defaultStatusText: IMultiSelectTexts = {
  //    checked: 'item selected',
  //    checkedPlural: 'items selected',
  //    defaultTitle: 'Status',
  //    checkAll: 'Select all',
  //    uncheckAll: 'Unselect all',
  //};
  defaultStatusSettings = {
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true
  };
  //defaultStateText: IMultiSelectTexts = {
  //    defaultTitle: 'State',
  //    searchEmptyResult: 'No results found...',
  //};
  defaultStateSettings = {
    checkedStyle: 'fontawesome',
    enableSearch: true,
    selectionLimit: 1,
    autoUnselect: true,
    closeOnSelect: true,
    closeOnClickOutside: true,
    buttonClasses: 'btn btn-default btn-block',
  };
  //defaultBrokerText: IMultiSelectTexts = {
  //    defaultTitle: 'Select',
  //    searchEmptyResult: 'No results found...',
  //};

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;


  constructor(private _commonService: CommonService, private modalService: BsModalService, private http: HttpClient, private authService: AuthenticationService, private _propertyManagerService: PropertyManagementService, private _toastService: ToastService,
    private router: Router, /*private completerService: CompleterService, */public _validationService: ValidationService, private _offerService: OfferService, private _loader: LoaderService, private activatedRoute: ActivatedRoute) {
    //const remoteDataProvider = completerService.remote(this.BASE_URL + '/property/propertiesByAutocomplete/', 'PropertyName', 'PropertyName');
    //remoteDataProvider.urlFormater(x => {
    //    return encodeURI(this.BASE_URL + '/property/propertiesByAutocomplete/' + x);
    //});
    //this.dataService = remoteDataProvider;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let fromMenu = params['fromMenu'];
      if (fromMenu !== null && fromMenu !== undefined) {
        this.currentMenu = fromMenu;
      }
    });
  }
  ngOnInit() {

    //this._commonService.getStateList().subscribe(response => {
    //    if (response != null && response.length > 0) {
    //        this.inputStates = response.map(o => { return { id: o.Id, name: o.StateName } });
    //    }
    //});
    //this._commonService.getBrokersNames().subscribe(response => {
    //    if (response != null && response.length > 0) {
    //        this.inputBrokers = response.map(o => { return { id: o.LeadContactId, name: o.BrokerName } });
    //    }
    //});
    this._commonService.getLookupsByTypeId(8).subscribe(response => {

      this.statusList = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });

      if (this.statusList.findIndex(x => x.id == OfferStatus.Closed) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Closed).description = 'Close';
      }

      if (this.statusList.findIndex(x => x.id == OfferStatus.Cancelled) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Cancelled).description = 'Cancel';
      }

      if (this.statusList.findIndex(x => x.id == OfferStatus.Declined) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Declined).description = 'Decline';
      }

      if (this.statusList.findIndex(x => x.id == OfferStatus.Rejected) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Rejected).description = 'Reject';
      }

      if (this.statusList.findIndex(x => x.id == OfferStatus.OfferAccepted) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.OfferAccepted).description = 'Accept Offer';
      }

      if (this.statusList.findIndex(x => x.id == OfferStatus.Countered) !== -1) {
        this.statusList.find(x => x.id == OfferStatus.Countered).description = 'Counter';
      }
      const index: number = this.statusList.findIndex(x => x.id == OfferStatus.Draft);
      if (index !== -1) {
        this.statusList.splice(index, 1);
      }

      this.statusListForSearch = response.map(o => {
        return {
          id: o.Id, name: o.Description
        };
      });
    });
    this.isDisabled = false;
    this.user = this.authService.user;
    var loggedinUserId = this.user.Id;
    if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
      this.offersSearchCriteriaModel.LeadContactId = loggedinUserId;
      this.isDisabled = true;
      this.loggedInUserRole = UserRole.Broker;
    }
    else {
      this.offersSearchCriteriaModel.LeadContactId = 0;
      if (this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)) {
        this.loggedInUserRole = UserRole.SuperAdmin;
      }
      else {
        this.loggedInUserRole = UserRole.Admin;
      }
    }

    this.offersSearchCriteriaModel.PropertyType = this.propertyType.Exchange1031;

    this.bindLeadSummary();

    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[6, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        dataTablesParameters.Extra_param = this.offersSearchCriteriaModel;
        dataTablesParameters.Extra_param.UserId = that.user.Id;
        const httpHeader = this._validationService.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/opportunity/leads',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.offers = resp.data ? resp.data : [];
            if (this.firstPageLoad) {
              this.offersCount = that.offers.length;
              if (this.currentTab == that.propertyType.Exchange1031) {
                this.exchange1031Count = resp.recordsTotal;
              }
              else {
                this.saleCount = resp.recordsTotal;
              }
              this.firstPageLoad = false;
            }

            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columnDefs: [
        { orderable: false, targets: 1 }
      ],
      columns: [{ data: 'LeadId' },
      { data: 'LeadId' },
      { data: 'LeadId' },
      { data: 'LeadName' },
      { data: 'TenantName' },
      { data: 'PrimaryContactName' },
      { data: 'OfferDate' },
      { data: 'Price' },
      { data: 'OfferPrice' },
      { data: 'EarnestMoneyDeposit' },
      { data: 'DueDiligencePeriod' },
      { data: 'ClosingPeriod' },
      { data: 'Comments' },
      { data: 'StatusName' },


      ]
    };
  }
  onResetClick($event) {
    this.defaultSearchCriteriaValues();
    this.dtElement.dtInstance.then(x => x.draw());
  }

  checkboxSelectionList = [];

  onCheckboxSelection(data) {
    if (data.IsChecked) {
      this.checkboxSelectionList.push(data.LeadId);
    }
    else {
      const index: number = this.checkboxSelectionList.indexOf(data.LeadId);
      if (index !== -1) {
        this.checkboxSelectionList.splice(index, 1);
      }
    }
  }

  onActionSelect(event, template: TemplateRef<any>, classes: any, ChangeStatus: TemplateRef<any>) {
    if (this.selectedAction !== Actions.NothingSelected) {
      if (this.checkboxSelectionList.length < 1) {
        this._toastService.addToast({
          title: 'Error', msg:
            'Select at least one item to make the change', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
        this.selectedAction = Actions.NothingSelected;
      }
      else {
        if (this.selectedAction == Actions.Delete) {
          this.openModal(template, classes, 0, 0);
        }
        else if (this.selectedAction == Actions.ChangeStatus) {
          this.selectedBulkStatus = 0;
          this.bulkStatusSubmit = false;
          this.modalRef = this.modalService.show(ChangeStatus, { class: 'panlestyle' });
        }
        else if (this.selectedAction == Actions.DownloadLOI) {
          this._toastService.addToast({
            title: 'Downloading..', msg:
              'Selected LOI documents are downloading.', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'wait'
          });

          this.checkboxSelectionList.forEach(item => {
            let offer = this.offers.find(x => x.LeadId == item);
            if (offer.LeadOfferId != null && offer.DocumentId != null) {
              this._offerService.downloadLOI(offer.LeadOfferId, 'doc', offer.DocumentId).subscribe(res => {

                this.filePathToDownload = res.toString().replace('~/src/', '../../../');
                let filename = this.filePathToDownload.toString().split('/');
                this._validationService.downloadFile(this.filePathToDownload, filename[filename.length - 1]);
                //var a = document.createElement('a');
                //document.body.appendChild(a);
                //a.setAttribute('style', 'display: none');
                //a.href = this.filePathToDownload;
                //a.download = filename[filename.length - 1];
                ////"LOI-" + offer.LeadName + "-" + offer.TenantName + ".pdf";
                //a.click();
                //a.remove(); // remove the element
              });
            }
          });

          this.offers.forEach(item => {
            item.IsChecked = false;
          });

          this.checkboxSelectionList = [];
        }
      }
    }
    event.target.value = 0;
  }

  downloads = [];


  filePathToDownload = "";

  bulkStatusSubmit = false;
  ChangeSelectedOffersStatus() {
    this.bulkStatusSubmit = true;
    this._loader.display(true);
    if (this.selectedBulkStatus !== 0) {
      this._offerService.ChangeSelectedOffersStatus(this.checkboxSelectionList, this.selectedBulkStatus).subscribe(res => {
        if (res) {
          this.bindLeadSummary();
          this.dtElement.dtInstance.then(x => x.draw());
          this.checkboxSelectionList = [];
          this.modalRef.hide();
          this._toastService.addToast({
            title: 'Success', msg:
              'Offers Status changed successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error changing status', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }
        this._loader.display(false);
      });
    }
    else {
      this._loader.display(false);
    }
  }

  selectedAction = Actions.NothingSelected;
  onTabClick(tab) {
    this._loader.display(true);
    this.currentTab = tab;
    this.firstPageLoad = true;
    this.checkboxSelectionList = [];
    this.activefilterButton = OfferStatus.Reset;
    this.defaultSearchCriteriaValues();
    this.offersSearchCriteriaModel.PropertyType = tab;
    this.bindLeadSummary();
    this.dtElement.dtInstance.then(x => x.draw());
    this._loader.display(false);
  }

  activefilterButton = OfferStatus.Reset;

  filterByStatus(statusid, event) {
    this._loader.display(true);
    this.checkboxSelectionList = [];
    this.activefilterButton = statusid;
    let status = [];
    if (statusid != -1) {
      status.push(statusid);
      //if (statusid == OfferStatus.New) {
      //    status.push(OfferStatus.OfferModified);
      //}
    }
    this.offersSearchCriteriaModel.LeadStatusId = status;
    this.onStatusSelect(event);
    this._loader.display(false);
  }
  defaultSearchCriteriaValues() {
    this.offersSearchCriteriaModel.PropertyName = "";
    this.offersSearchCriteriaModel.BrokerName = null;
    this.offersSearchCriteriaModel.ClosingPeriodTo = 0;
    this.offersSearchCriteriaModel.ClosingPeriodFrom = 0;
    this.offersSearchCriteriaModel.DueDiligencePeriodFrom = 0;
    this.offersSearchCriteriaModel.DueDiligencePeriodTo = 0;
    this.offersSearchCriteriaModel.PriceFrom = 0;
    this.offersSearchCriteriaModel.PriceTo = 0;
    this.offersSearchCriteriaModel.PropertyId = 0;
    this.offersSearchCriteriaModel.LeadContactId = 0;
    this.offersSearchCriteriaModel.LeadStatusId = [];
    this.offersSearchCriteriaModel.StateId = 0;
    this.offersSearchCriteriaModel.PropertyType = this.propertyType.Exchange1031;

    if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
      this.offersSearchCriteriaModel.LeadContactId = this.user.Id;
      this.isDisabled = true;
    }
  }

  exchange1031Count = 0;
  saleCount = 0;
  firstPageLoad = true;
  leadSummary = [];


  New = "0";
  Reviewed = "0";
  OfferModified = "0";
  CounterAccepted = "0";
  CounterDeclined = "0";
  UnderContract = "0";
  Closed = "0";
  Rejected = "0";
  OfferAccepted = "0";
  Countered = "0";
  HardContract = "0";
  Draft = "0";
  NoActivitySinceLast10Days = "0";

  async bindLeadSummary() {
    const summaryInput =
    {
      PropertyType: this.offersSearchCriteriaModel.PropertyType,
      LeadContactId: this.offersSearchCriteriaModel.LeadContactId,
      LoggedInUserId: this.user.Id
    }
    await this._offerService.GetLeadSummary(summaryInput).subscribe(res => {
      this.leadSummary = res;
      this.New = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.New) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.New).Count) : "0";
      this.OfferModified = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.OfferModified) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.OfferModified).Count) : "0";
      this.Reviewed = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.Reviewed) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.Reviewed).Count) : "0";
      this.CounterAccepted = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.CounterAccepted) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.CounterAccepted).Count) : "0";
      this.CounterDeclined = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.CounterDeclined) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.CounterDeclined).Count) : "0";
      this.UnderContract = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.UnderContract) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.UnderContract).Count) : "0";
      this.Closed = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.Closed) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.Closed).Count) : "0";
      this.Rejected = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.Rejected) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.Rejected).Count) : "0";
      this.HardContract = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.HardContract) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.HardContract).Count) : "0";
      this.NoActivitySinceLast10Days = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.NoActivitySinceLast10Days) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.NoActivitySinceLast10Days).Count) : "0";
      this.Countered = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.Countered) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.Countered).Count) : "0";
      this.OfferAccepted = this.leadSummary.find(x => x.LeadStatusId == OfferStatus.OfferAccepted) ? this._validationService.formatNumberToTwoDigit(this.leadSummary.find(x => x.LeadStatusId == OfferStatus.OfferAccepted).Count) : "0";
    });
  }

  openModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.selectedOfferId = id;
    this.currentIndex = index;

    if (id == 0) {
      this.deletType = "selected offers";
    }
    else {
      this.deletType = "this offer";
    }
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  selectSattus(event) {
    this.selectedStatus = this._validationService.getSelectedOptionText(event);
  }

  changeOfferStatus(statusId: number, leadId: number, leadGuid: any) {
    let currentOffer = this.offers.find(x => x.LeadId == leadId);
    if (currentOffer.StatusId == 466 || currentOffer.StatusId == 467) {
      this._offerService.CheckNewOfferExistOnCancelledOffer(currentOffer.Id, currentOffer.PropertyGuid).subscribe(res => {
        if (res) {
          this._toastService.addToast({
            title: 'Error', msg: "Cannot change the status. Another offer from the same ID is progressing.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          })
        }
        else {
          this.offerStatusChange(statusId, leadGuid, leadId);
        }
      });
    }
    else {
      this.offerStatusChange(statusId, leadGuid, leadId);
    }
  }

  private offerStatusChange(statusId: number, leadGuid: any, leadId: number) {
    if (statusId == this.offerStatus.Countered) {
      this.router.navigate(['/counter-offer/' + leadGuid]);
    }
    else {
      this._loader.display(true);
      this.user = this.authService.user;
      var userId = this.user.Id;
      this._propertyManagerService.changeOfferStatus(statusId, leadId, userId).subscribe(response => {
        this.bindLeadSummary();
        this.dtElement.dtInstance.then(x => x.draw());
        this._toastService.addToast({
          title: 'Success', msg: 'Offer Status changed Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
        this._loader.display(false);
      });
      event.preventDefault();
    }
  }

  deleteOffers() {
    var loggedinUserId = this.user.Id;
    this._loader.display(true);
    var offerId = this.selectedOfferId;
    var index = this.currentIndex;
    if (offerId > 0) {
      this._propertyManagerService.deleteOffers(offerId, loggedinUserId).subscribe(response => {
        if (response.toString() == 'true') {
          const index: number = this.checkboxSelectionList.indexOf(offerId);
          if (index !== -1) {
            this.checkboxSelectionList.splice(index, 1);
          }
          this.offers.splice(index, 1);
          this.resetHeaderBadgeVales(1);
          this._toastService.addToast({
            title: 'Success', msg:
              'Offer deleted successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error deleting Offer', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }
        this.dtElement.dtInstance.then(x => x.draw());
        this._loader.display(false);
      });
    }
    else {
      this._offerService.DeleteSelectedOffers(this.checkboxSelectionList).subscribe(response => {
        if (response) {
          this.checkboxSelectionList.forEach(item => {
            const index: number = this.offers.findIndex(x => x.LeadId == item);
            if (index !== -1) {
              this.offers.splice(index, 1);
            }
          });
          this.resetHeaderBadgeVales(0);
          this.checkboxSelectionList = [];
          this._toastService.addToast({
            title: 'Success', msg:
              'Offers deleted successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error deleting Offers', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }
        this._loader.display(false);
      });
    }
  }
  resetHeaderBadgeVales(count) {
    if (this.currentTab == PropertyType.Exchange1031) {
      this.exchange1031Count = this.exchange1031Count - (count === 0 ? this.checkboxSelectionList.length : count);
    }
    else if (this.currentTab == PropertyType.Sale) {
      this.saleCount = this.saleCount - (count === 0 ? this.checkboxSelectionList.length : count);
    }
    this.bindLeadSummary();
  }

  onSearch(text: string) {

    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  openModalForNotes(template: TemplateRef<any>, classes, offer) {
    this.isSubmit = false;
    this.NotesInput.Id = 0;
    this.NotesInput.Description = '';
    this.NotesInput.UserId = this.user.Id;
    this.NotesInput.ObjectId = offer.LeadId;
    this.NotesInput.ObjectTypeId = 303;
    offer.UnReadNoteCount = 0;
    this.modalRef = this.modalService.show(template, { class: classes });
  }


  IsNull(val) {
    if (val == null || val == "0" || val == undefined) {
      return '';
    }
    return val;
  }

  onPropertySelect($event) {
    if ($event.originalObject) {
      this.offersSearchCriteriaModel.PropertyId = $event.originalObject.Id;
      this.dtElement.dtInstance.then(x => x.draw());
    }
  }
  onBrokerSelect($event) {
    if ($event.originalObject) {
      this.offersSearchCriteriaModel.LeadContactId = $event.originalObject.Id;
      this.dtElement.dtInstance.then(x => x.draw());
    }
  }
  onStatusSelect($event) {
    if (this.offersSearchCriteriaModel.LeadStatusId != undefined) {
      this.dtElement.dtInstance.then(x => x.draw());
    }
  }

  onFilter(event) {

    if (this.offersSearchCriteriaModel.StateId != undefined) {
      var a = this.offersSearchCriteriaModel.StateId.toString();
      this.offersSearchCriteriaModel.StateId = parseInt(a);
    }
    if (this.offersSearchCriteriaModel.LeadContactId != undefined) {
      var a = this.offersSearchCriteriaModel.LeadContactId.toString();
      this.offersSearchCriteriaModel.LeadContactId = parseInt(a);
    }
    this.dtElement.dtInstance.then(x => x.draw());
    $("#btnMore").click();
  }
  convertUTCDateToLocalOfferDate(OfferDate: Date) {
    var newDate = new Date(OfferDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - (offset * 60 * 1000 * 60));
    return offsetTime;
  }

  statusListFilter(statusId) {
    if (statusId == 451 || statusId == 461 || statusId == 458) {
      return this.statusList.filter(x => (x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted
        || x.id == this.offerStatus.Declined || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Cancelled));
    }
    if (statusId == 466 || statusId == 467) {
      return this.statusList.filter(x => (x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.New
        || x.id == this.offerStatus.Declined || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.HardContract));
    }
    if (statusId == 460) {
      return this.statusList.filter(x => (x.id == this.offerStatus.New || x.id == this.offerStatus.Countered
        || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Closed || x.id == this.offerStatus.Cancelled) && x.id !== statusId);
    }
    if (statusId == 455) {
      return this.statusList.filter(x => (x.id == this.offerStatus.New || x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Closed || x.id == this.offerStatus.Cancelled) && x.id !== statusId);
    }

    if (statusId == 462) {
      return this.statusList.filter(x => (x.id == this.offerStatus.New || x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.Closed || x.id == this.offerStatus.Cancelled) && x.id !== statusId);
    }

    if (statusId == 456) {
      return this.statusList.filter(x => (x.id == this.offerStatus.New || x.id == this.offerStatus.Countered || x.id == this.offerStatus.OfferAccepted || x.id == this.offerStatus.UnderContract || x.id == this.offerStatus.HardContract || x.id == this.offerStatus.Cancelled) && x.id !== statusId);
    }
  }
}
